import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { BankAccountSelectorComponent } from './bank-account-selector.component';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatSelectModule,
    ],
    declarations: [BankAccountSelectorComponent],
    exports: [BankAccountSelectorComponent],
})
export class BankAccountSelectorModule
{
}
